module.exports = __webpack_public_path__ + "img/waiting-queue.dc6a26bb.png";